module.exports = __webpack_public_path__ + "img/map_resort.478f126f.jpg";